require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("prop-types"), require("react"), require("react-dom"), require("mobiledoc-kit")) : "function" == typeof define && define.amd ? define("ReactMobiledocEditor", ["prop-types", "react", "react-dom", "mobiledoc-kit"], t) : "object" == typeof exports ? exports.ReactMobiledocEditor = t(require("prop-types"), require("react"), require("react-dom"), require("mobiledoc-kit")) : e.ReactMobiledocEditor = t(e["prop-types"], e.react, e["react-dom"], e["mobiledoc-kit"]);
}("undefined" != typeof self ? self : this, function (e, t, r, n) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 4);
  }([function (t, r) {
    t.exports = e;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t) {
    e.exports = n;
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(1),
        o = r.n(n),
        a = r(2),
        i = r.n(a);

    function c(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {},
            n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
          return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), n.forEach(function (t) {
          u(e, t, r[t]);
        });
      }

      return e;
    }

    function u(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    var l = function l(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      return function (r) {
        var n = r.env,
            a = r.options,
            u = r.payload,
            l = document.createElement("div"),
            s = n.didRender,
            f = n.onTeardown;
        return s(function () {
          u = c({}, u);
          var r = a.cardProps,
              s = o.a.createElement(e, c({}, n, r, {
            payload: u,
            isEditing: t
          }));
          i.a.render(s, l);
        }), f(function () {
          return i.a.unmountComponentAtNode(l);
        }), l;
      };
    },
        s = function s(e) {
      if (!e.displayName) throw new Error("Can't create card from component, no displayName defined: " + e);
      return {
        name: e.displayName,
        component: e,
        type: "dom",
        render: l(e),
        edit: l(e, !0)
      };
    };

    function f(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {},
            n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
          return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), n.forEach(function (t) {
          p(e, t, r[t]);
        });
      }

      return e;
    }

    function p(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    var d = function d(e) {
      return function (t) {
        var r = t.env,
            n = t.options,
            a = t.payload,
            c = t.value,
            u = r.onTeardown,
            l = o.a.createElement(e, f({}, r, n, {
          value: c,
          payload: f({}, a)
        })),
            s = document.createElement("span");
        return i.a.render(l, s), u(function () {
          return i.a.unmountComponentAtNode(s);
        }), s;
      };
    },
        y = function y(e) {
      if (!e.displayName) throw new Error("Can't create atom from component, no displayName defined: ".concat(e));
      return {
        name: e.displayName,
        component: e,
        type: "dom",
        render: d(e)
      };
    },
        b = {
      version: "0.3.1",
      markups: [],
      atoms: [],
      cards: [],
      sections: [[1, "p", []]]
    },
        m = r(0),
        v = r.n(m),
        g = r(3),
        O = r.n(g);

    function h(e) {
      return (h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function j(e, t) {
      if (null == e) return {};

      var r,
          n,
          o = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            o = {},
            a = Object.keys(e);

        for (n = 0; n < a.length; n++) {
          r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
        }

        return o;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (n = 0; n < a.length; n++) {
          r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
        }
      }

      return o;
    }

    function w(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function E(e) {
      return (E = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function P(e, t) {
      return (P = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function S(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function k(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    var C = function (e) {
      function t() {
        var e, r, n, o;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var a = arguments.length, i = new Array(a), c = 0; c < a; c++) {
          i[c] = arguments[c];
        }

        return n = this, o = (e = E(t)).call.apply(e, [this].concat(i)), r = !o || "object" !== h(o) && "function" != typeof o ? S(n) : o, k(S(S(r)), "state", {
          activeMarkupTags: [],
          activeSectionTags: []
        }), k(S(S(r)), "setActiveTags", function () {
          r.setState({
            activeMarkupTags: r.editor.activeMarkups.map(function (e) {
              return e.tagName;
            }),
            activeSectionTags: r.editor.activeSections.map(function (e) {
              return e.isNested ? e.parent.tagName : e.tagName;
            })
          });
        }), r;
      }

      var r, n, a;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && P(e, t);
      }(t, o.a.Component), r = t, (n = [{
        key: "getChildContext",
        value: function value() {
          return {
            editor: this.editor,
            activeMarkupTags: this.state.activeMarkupTags,
            activeSectionTags: this.state.activeSectionTags
          };
        }
      }, {
        key: "componentWillMount",
        value: function value() {
          var e = this;
          "function" == typeof this.props.willCreateEditor && this.props.willCreateEditor();

          var t = this.props,
              r = t.atoms,
              n = t.autofocus,
              o = t.cardProps,
              a = t.cards,
              i = t.html,
              c = t.placeholder,
              u = t.serializeVersion,
              l = t.spellcheck,
              s = this.props.mobiledoc || (i ? void 0 : b),
              f = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {},
                  n = Object.keys(r);
              "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
                return Object.getOwnPropertyDescriptor(r, e).enumerable;
              }))), n.forEach(function (t) {
                k(e, t, r[t]);
              });
            }

            return e;
          }({}, this.props.options, {
            atoms: r,
            autofocus: n,
            cardOptions: {
              cardProps: o
            },
            cards: a,
            html: i,
            mobiledoc: s,
            placeholder: c,
            serializeVersion: u,
            spellcheck: l
          });

          this.editor = new O.a.Editor(f), this.editor.inputModeDidChange(this.setActiveTags), "function" == typeof this.props.onChange && this.editor.postDidChange(function () {
            var t = e.editor.serialize(e.props.serializeVersion);
            e.props.onChange(t);
          }), "function" == typeof this.props.didCreateEditor && this.props.didCreateEditor(this.editor);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.editor.destroy();
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = (e.atoms, e.autofocus, e.cardProps, e.cards, e.children),
              r = (e.didCreateEditor, e.html, e.mobiledoc, e.options, e.placeholder, e.serializeVersion, e.spellcheck, e.willCreateEditor, j(e, ["atoms", "autofocus", "cardProps", "cards", "children", "didCreateEditor", "html", "mobiledoc", "options", "placeholder", "serializeVersion", "spellcheck", "willCreateEditor"]));
          return o.a.createElement("div", r, t);
        }
      }]) && w(r.prototype, n), a && w(r, a), t;
    }();

    k(C, "defaultProps", {
      atoms: [],
      autofocus: !0,
      cardProps: {},
      cards: [],
      placeholder: "",
      serializeVersion: "0.3.1",
      spellcheck: !0
    }), k(C, "childContextTypes", {
      editor: v.a.object,
      activeMarkupTags: v.a.array,
      activeSectionTags: v.a.array
    }), C.propTypes = {
      atoms: v.a.array,
      autofocus: v.a.bool,
      cards: v.a.array,
      didCreateEditor: v.a.func,
      html: v.a.string,
      mobiledoc: v.a.object,
      onChange: v.a.func,
      options: v.a.object,
      placeholder: v.a.string,
      serializeVersion: v.a.string,
      spellcheck: v.a.bool,
      willCreateEditor: v.a.func
    };
    var T = C;

    function x(e) {
      return (x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function M() {
      return (M = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function N(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function _(e, t) {
      return !t || "object" !== x(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function q(e) {
      return (q = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function D(e, t) {
      return (D = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var R,
        z,
        A,
        L = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), _(this, q(t).apply(this, arguments));
      }

      var r, n, a;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && D(e, t);
      }(t, o.a.Component), r = t, (n = [{
        key: "componentDidMount",
        value: function value() {
          var e = this.context.editor;
          e && e.render(this.editorEl);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this;
          return o.a.createElement("div", M({}, this.props, {
            ref: function ref(t) {
              return e.editorEl = t;
            }
          }));
        }
      }]) && N(r.prototype, n), a && N(r, a), t;
    }();

    R = L, z = "contextTypes", A = {
      editor: v.a.object
    }, z in R ? Object.defineProperty(R, z, {
      value: A,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : R[z] = A;
    var B = L;

    function I(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function V(e, t) {
      if (null == e) return {};

      var r,
          n,
          o = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            o = {},
            a = Object.keys(e);

        for (n = 0; n < a.length; n++) {
          r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
        }

        return o;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (n = 0; n < a.length; n++) {
          r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
        }
      }

      return o;
    }

    var U = function U(e, t) {
      var r = t.editor,
          n = t.activeMarkupTags,
          a = void 0 === n ? [] : n,
          i = e.children,
          c = void 0 === i ? "Link" : i,
          u = e.type,
          l = void 0 === u ? "button" : u,
          s = e.handler,
          f = e.className,
          p = e.activeClassName,
          d = void 0 === p ? "active" : p,
          y = V(e, ["children", "type", "handler", "className", "activeClassName"]);
      return y = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {},
              n = Object.keys(r);
          "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
          }))), n.forEach(function (t) {
            I(e, t, r[t]);
          });
        }

        return e;
      }({
        type: l
      }, y, {
        onClick: function onClick() {
          r.hasCursor() && (r.hasActiveMarkup("a") ? r.toggleMarkup("a") : g.UI.toggleLink(r, s));
        },
        className: f = [f, a.indexOf("a") > -1 && d].filter(Boolean).join(" ")
      }), o.a.createElement("button", y, c);
    };

    U.propTypes = {
      children: v.a.node
    }, U.contextTypes = {
      editor: v.a.object,
      activeMarkupTags: v.a.array
    };

    var W = U,
        Y = function Y(e) {
      return "".concat(e.charAt(0).toUpperCase()).concat(e.slice(1));
    };

    function F(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function G(e, t) {
      if (null == e) return {};

      var r,
          n,
          o = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            o = {},
            a = Object.keys(e);

        for (n = 0; n < a.length; n++) {
          r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
        }

        return o;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (n = 0; n < a.length; n++) {
          r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
        }
      }

      return o;
    }

    var H = function H(e, t) {
      var r = t.editor,
          n = t.activeMarkupTags,
          a = void 0 === n ? [] : n,
          i = e.tag,
          c = void 0 === i ? "" : i,
          u = e.type,
          l = void 0 === u ? "button" : u,
          s = e.children,
          f = void 0 === s ? Y(c) : s,
          p = e.className,
          d = e.activeClassName,
          y = void 0 === d ? "active" : d,
          b = G(e, ["tag", "type", "children", "className", "activeClassName"]);
      return b = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {},
              n = Object.keys(r);
          "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
          }))), n.forEach(function (t) {
            F(e, t, r[t]);
          });
        }

        return e;
      }({
        type: l
      }, b, {
        onClick: function onClick() {
          return r.toggleMarkup(c);
        },
        className: p = [p, a.indexOf(c.toLowerCase()) > -1 && y].filter(Boolean).join(" ")
      }), o.a.createElement("button", b, f);
    };

    H.propTypes = {
      tag: v.a.string.isRequired,
      children: v.a.node
    }, H.contextTypes = {
      editor: v.a.object,
      activeMarkupTags: v.a.array
    };
    var J = H;

    function K(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Q(e, t) {
      if (null == e) return {};

      var r,
          n,
          o = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            o = {},
            a = Object.keys(e);

        for (n = 0; n < a.length; n++) {
          r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
        }

        return o;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (n = 0; n < a.length; n++) {
          r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
        }
      }

      return o;
    }

    var X = function X(e, t) {
      var r = t.editor,
          n = t.activeSectionTags,
          a = void 0 === n ? [] : n,
          i = e.tag,
          c = void 0 === i ? "" : i,
          u = e.type,
          l = void 0 === u ? "button" : u,
          s = e.children,
          f = void 0 === s ? Y(c) : s,
          p = e.className,
          d = e.activeClassName,
          y = void 0 === d ? "active" : d,
          b = Q(e, ["tag", "type", "children", "className", "activeClassName"]);
      return b = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {},
              n = Object.keys(r);
          "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
          }))), n.forEach(function (t) {
            K(e, t, r[t]);
          });
        }

        return e;
      }({
        type: l
      }, b, {
        onClick: function onClick() {
          return r.toggleSection(c);
        },
        className: p = [p, a.indexOf(c.toLowerCase()) > -1 && y].filter(Boolean).join(" ")
      }), o.a.createElement("button", b, f);
    };

    X.propTypes = {
      tag: v.a.string.isRequired,
      children: v.a.node
    }, X.contextTypes = {
      editor: v.a.object,
      activeSectionTags: v.a.array
    };
    var Z = X;

    function $() {
      return ($ = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function ee(e, t) {
      if (null == e) return {};

      var r,
          n,
          o = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            o = {},
            a = Object.keys(e);

        for (n = 0; n < a.length; n++) {
          r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
        }

        return o;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (n = 0; n < a.length; n++) {
          r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
        }
      }

      return o;
    }

    var te = function te(e, t) {
      var r = t.editor,
          n = t.activeSectionTags,
          a = void 0 === n ? [] : n,
          i = e.tags,
          c = void 0 === i ? [] : i,
          u = ee(e, ["tags"]),
          l = function l() {
        return c.find(function (e) {
          return a.includes(e);
        });
      };

      return o.a.createElement("select", $({
        value: l() || "",
        onChange: function onChange(e) {
          var t = e.target.value || l();
          r.toggleSection(t);
        }
      }, u), o.a.createElement("option", {
        value: ""
      }), c.map(function (e) {
        return o.a.createElement("option", {
          value: e,
          key: e
        }, e.toUpperCase());
      }));
    };

    te.propTypes = {
      tags: v.a.arrayOf(v.a.oneOf(["p", "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "aside"])).isRequired
    }, te.contextTypes = {
      editor: v.a.object,
      activeSectionTags: v.a.array
    };

    var re = te,
        ne = function ne(e) {
      return o.a.createElement("ul", e, o.a.createElement("li", null, o.a.createElement(J, {
        tag: "strong"
      })), o.a.createElement("li", null, o.a.createElement(J, {
        tag: "em"
      })), o.a.createElement("li", null, o.a.createElement(W, null)), o.a.createElement("li", null, "Style: ", o.a.createElement(re, {
        tags: ["h1", "h2", "h3"]
      })), o.a.createElement("li", null, o.a.createElement(Z, {
        tag: "blockquote"
      })), o.a.createElement("li", null, o.a.createElement(Z, {
        tag: "ul"
      }, "UL")), o.a.createElement("li", null, o.a.createElement(Z, {
        tag: "ol"
      }, "OL")));
    };

    r.d(t, "classToDOMCard", function () {
      return s;
    }), r.d(t, "classToDOMAtom", function () {
      return y;
    }), r.d(t, "EMPTY_MOBILEDOC", function () {
      return b;
    }), r.d(t, "Container", function () {
      return T;
    }), r.d(t, "Editor", function () {
      return B;
    }), r.d(t, "LinkButton", function () {
      return W;
    }), r.d(t, "MarkupButton", function () {
      return J;
    }), r.d(t, "SectionButton", function () {
      return Z;
    }), r.d(t, "SectionSelect", function () {
      return re;
    }), r.d(t, "Toolbar", function () {
      return ne;
    });
  }]);
});